import { isTiptapTextValid } from '../../../../utils/is-tiptap-text-valid'

import type { IHighlight } from '../_types/types'

/**
 * Filters highlight items to those that have at least one of: image, valid title, or valid description.
 * Exported for use in parent projects to pre-filter highlights before passing to MDividerImagesA.
 */
export function isBlockValid(highlights: IHighlight[]): IHighlight[] {
	return highlights.filter(
		highlight =>
			highlight.image ||
			(highlight.title != null && isTiptapTextValid(highlight.title)) ||
			(highlight.description != null && isTiptapTextValid(highlight.description))
	)
}
